/**
 * Close zoom
 *
 * @param {JQuery} target - target
 * @returns {void}
 */
export const hideZoom = target => {
    const $main = $('#pdpMain');
    const $target = target !== undefined ? $(target) : $main.find('.product-images-top').find('#zoom-overlay');

    $target.hide(400);

    $main.find('.main-image').trigger('zoom.destroy');

    $target.find('img').not('.zoom-background-image').remove();

    $('.product-zoom.zoom-in-link').removeClass('inactive');
    $('.product-zoom.zoom-out-link').addClass('inactive');
};

/**
 * Puts the product video in the overlay
 *
 * @param {Object} atts iFrame code
 * @returns {void}
 */
const _loadVideoAttributes = atts => {
    const topImage = $('#pdpMain .product-images-top');
    const $zoomOverlay = topImage.find('#zoom-overlay');
    const $imageOverlay = topImage.find('.product-image-overlay');
    const $controlls360 = topImage.find('.image-controlls .product-360');
    const $controllsZoom = topImage.find('.image-controlls .product-zoom');

    $imageOverlay.find('.product-image-overlay-content').html(atts.url);
    $imageOverlay.addClass('loaded');

    if ($zoomOverlay.is(':visible')) {
        hideZoom();
    }

    if (!$imageOverlay.is(':visible')) {
        $imageOverlay.show();
    }

    $controlls360.hide();
    $controllsZoom.hide();
};
/**
 * Synchronizes the selection of vertical and horizontal carousel
 *
 * @param {JQuery} selectedItem - selectedItem
 * @returns {void}
 */
export const switchIndicator = selectedItem => {
    if (selectedItem && selectedItem !== undefined) {
        const selectedIndex = $(selectedItem).closest('li').index();
        const $carousels = $('.carousel-container');

        $carousels.find('.thumb.selected').removeClass('selected');
        $carousels.find(`.thumb:eq(${selectedIndex})`).addClass('selected');
    }
};

/**
 * Shows youtube video.
 *
 * @returns {void}
 */
export const showVideoContent = () => {
    $('.product-videolink').each(function () {
        _loadVideoAttributes($(this).data('video'));

        $(this).find('.product-image-overlay').show();
    });
};

/**
 * Attaches youtube video events.
 *
 * @returns {void}
 */
export const attachVideoEvents = () => {
    $('#pdpMain').on('click', '.product-videolink', function (e) {
        e.preventDefault();

        switchIndicator($(this));
        _loadVideoAttributes($(this).data('video'));
    });
};
